import { forwardRef, useImperativeHandle, useState } from "react";
import { ApiResponseType } from "../../../../common/api/apiHelper";
import Modal from "../../Modal";
import Button from "../../Elements/Button";
import { useNavigate } from "react-router-dom";
import { getNavigationUrl } from "../../../../common/helpers/navigationHelpers";

interface UploadCustomerExcelModal {
    statusModalVisible: boolean;
    setStatusModalVisible: (visible: boolean) => void;
}

export interface UploadCustomerExcelModalHandles {
    getResult: (erpCustomerTransferResults: any) => void;
}

const UploadCustomerExcelModal = forwardRef<UploadCustomerExcelModalHandles, UploadCustomerExcelModal>(
    ({ statusModalVisible, setStatusModalVisible }, ref) => {
        const [integrationResult, setIntegrationResult] = useState<ApiResponseType>({
            isSuccess: false,
            data: null,
            errorMessage: ""
        });

        useImperativeHandle(ref, () => ({
            getResult(erpCustomerTransferResults: ApiResponseType) {
                setIntegrationResult(erpCustomerTransferResults);
            }
        }));

        const navigate = useNavigate();

        const MessageRow = ({ label, value }: { label: string, value: string | number }) => (
            <div className='my-1 py-1 flex flex-row'>
                <h3 className='basis-5/12 font-bold text-black-50 text-sm text-right min-w-[164px]'>{label} :</h3>
                <div className="basis-7/12 text-sm text-left pl-2 max-w-[90px]">{value}</div>
            </div>
        );

        const getMessage = () => {
            const { successfullCustomer, unsuccessfullCustomer, updatedCustomer } = integrationResult.data || {};
            
            if (integrationResult.isSuccess && integrationResult.data) {
                return (
                    <div className='m-1 p-1 max-w-[auto] flex-row items-center'>
                        <MessageRow label="Başarılı Kayıt Sayısı" value={successfullCustomer || 0} />
                        <MessageRow label="Güncellenen Kayıt Sayısı" value={updatedCustomer || 0} />
                        <MessageRow label="Başarısız Kayıt Sayısı" value={unsuccessfullCustomer || 0} />
                    </div>
                );
            } else {
                return (
                    <div className='flex flex-col items-center justify-center w-[auto]'>
                        <div className='flex pb-2'>
                            <h3 className='flex items-center justify-end min-w-[77px]'>Hata Mesajı:</h3>
                            <div className="flex justify-start text-left pl-2 min-w-[175px]">
                                {integrationResult.errorMessage}
                            </div>
                        </div>
                    </div>
                );
            }
        };

        const handleClose = () => {
            navigate(getNavigationUrl("/musteri-listesi"));
            setStatusModalVisible(false);
        };

        const statusImageUrl = integrationResult.isSuccess ? "/icons/basarili.svg" : "/icons/basarisiz.svg";

        return (
            <Modal openModal={statusModalVisible} setOpenModal={setStatusModalVisible}>
                <div>
                    <div className="sm:flex sm:items-start">
                        <div className="flex flex-col items-center mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 className="text-lg leading-6 font-large text-gray-900">Bilgilendirme Mesajı</h3>
                            <div className="flex flex-row w-[320px] mt-4 justify-center">
                                <div className='flex items-center'>
                                    <div className="flex w-[auto] h-max items-center">
                                        <img className="flex text-success h-10 w-10" src={statusImageUrl} alt="status" />
                                    </div>
                                </div>
                                <div className="xl:basis-1/3 lg:basis-1/2 md:basis-1/2 sm:basis-1/2 m-1 p-1">
                                    {getMessage()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-1 sm:mt-4 flex justify-end space-x-2">
                        <Button color="gray" hover="gray" size="xs" callback={handleClose}>
                            Kapat
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    });

export default UploadCustomerExcelModal;
